<template>
  <div class="hello uk-container uk-container-expand uk-background-muted">
    <archivedContainerTableView></archivedContainerTableView>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import archivedContainerTableView from './ArchivedContainerTableView.vue';

export default defineComponent({
  name: 'HelloWorld',
  props: {
    msg: String,
  },
  components: {
    archivedContainerTableView,
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
